import DemoRenderer__LegacyDemoInstructions from '@runtime/DemoRenderer';
import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import legacyImportDemo_917204365 from "../../../../../packages/component/src/components/radio/demo/demo1.js?loadDemo";
import legacyImportDemo_1496397550 from "../../../../../packages/component/src/components/radio/demo/demo2.js?loadDemo";
import legacyImportDemo_360642383 from "../../../../../packages/component/src/components/radio/demo/demo3.js?loadDemo";
import legacyImportDemo_1473826984 from "../../../../../packages/component/src/components/radio/demo/demo4.js?loadDemo";
import * as React from 'react';
export default {
  DemoRenderer__LegacyDemoInstructions,
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  legacyImportDemo_917204365,
  legacyImportDemo_1496397550,
  legacyImportDemo_360642383,
  legacyImportDemo_1473826984,
  React
};